import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Eye, EyeOff, Star } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl, formatError, FALLBACK_COVER } from "@/lib/api";
import { ReleaseForm } from "./ReleaseForm";
import { ConfirmDelete } from "./ConfirmDelete";

export const AdminReleases = ({ onChange }) => {
  const [list, setList] = useState([]);
  const [artists, setArtists] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => {
    api.get("/admin/releases").then((r) => setList(r.data));
    api.get("/artists").then((r) => setArtists(r.data));
  };
  useEffect(load, []);

  const remove = async (id) => {
    try { await api.delete(`/admin/releases/${id}`); toast.success("Uscita eliminata"); load(); onChange?.(); }
    catch (e) { toast.error(formatError(e)); }
  };

  if (editing) return (
    <div>
      <h2 className="font-display text-2xl font-bold uppercase tracking-tight mb-8">{editing.id ? "Modifica uscita" : "Nuova uscita"}</h2>
      <ReleaseForm initial={editing} artists={artists} onCancel={() => setEditing(null)} onSaved={() => { setEditing(null); load(); onChange?.(); }} />
    </div>
  );

  return (
    <div data-testid="admin-releases">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display text-2xl font-bold uppercase tracking-tight">Uscite</h2>
        <button onClick={() => setEditing({})} data-testid="admin-new-release-btn" className="inline-flex items-center gap-2 rounded-full bg-emerald-500 text-black px-5 py-2.5 text-sm font-semibold hover:bg-emerald-400"><Plus className="h-4 w-4" /> Nuova uscita</button>
      </div>
      {!list.length && <p className="text-sm text-zinc-400 border border-dashed border-white/15 p-10 text-center" data-testid="admin-releases-empty">Nessuna uscita. Clicca "Nuova uscita" per pubblicare il tuo primo brano.</p>}
      <div className="space-y-2">
        {list.map((r) => (
          <div key={r.id} className="flex items-center gap-4 border border-white/10 bg-[#0d0e12] p-3 hover:border-emerald-500/30 transition-colors" data-testid={`admin-release-row-${r.id}`}>
            <img src={fileUrl(r.cover_url) || FALLBACK_COVER} alt="" className="h-14 w-14 object-cover" />
            <div className="flex-1 min-w-0">
              <p className="font-semibold truncate flex items-center gap-2">{r.title}{r.featured && <Star className="h-3.5 w-3.5 text-amber-400 fill-amber-400" />}</p>
              <p className="text-xs text-zinc-400 truncate">{[r.catalog_number, r.artist_name, r.release_type, `${r.tracks?.length || 0} brani`].filter(Boolean).join(" · ")}</p>
            </div>
            <span className={`hidden sm:inline-flex items-center gap-1 text-xs font-mono-tga ${r.published ? "text-emerald-400" : "text-zinc-500"}`}>
              {r.published ? <Eye className="h-3.5 w-3.5" /> : <EyeOff className="h-3.5 w-3.5" />}{r.published ? "Online" : "Bozza"}
            </span>
            <button onClick={() => setEditing(r)} className="p-2 text-zinc-400 hover:text-white" aria-label="Modifica" data-testid={`admin-edit-release-${r.id}`}><Pencil className="h-4 w-4" /></button>
            <ConfirmDelete onConfirm={() => remove(r.id)} testid={`admin-delete-release-${r.id}`} title={`Eliminare "${r.title}"?`}>
              <Trash2 className="h-4 w-4" />
            </ConfirmDelete>
          </div>
        ))}
      </div>
    </div>
  );
};
